<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <CoachingSessionForm :baseCoachingSession="coachingSession" :baseMessages="messages" :basecoachingSessionName="name" :loading="loading" @submit-requested="submitRequested"></CoachingSessionForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import CoachingSessionForm from './CoachingSessionForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                coachingSession: null,
                messages: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { CoachingSessionForm },
        computed:
        {
            ...mapState('coachingSessions', ['getCoachingSessionByIdOutput']),
            ...mapState('messages', ['getMessagesByIdOutput'])
        },
        methods: {
            ...mapActions('coachingSessions', ['getCoachingSessionById']),
            ...mapActions('coachingSessions', ['putCoachingSession']),
            ...mapActions('messages', ['getMessageById']),
            submitRequested(coachingSession) {
                this.putCoachingSession(coachingSession);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({name: "CoachingSessions" });
            }
            else {
                this.getCoachingSessionById(this.$route.query.id);
                this.getMessageById(this.$route.query.id);
            }
        },
        watch:
        {
            getCoachingSessionByIdOutput: function (output) {
                if (!output && !output.data) {
                    router.push({name: "CoachingSessions" });
                }
                else {
                    this.coachingSession = output.data;
                    this.loading = false;
                }
            },
            getMessagesByIdOutput: function (output) {
                if (!output && !output.data) {
                    router.push({name: "CoachingSessions" });
                }
                else {
                    this.messages = output.data;
                    this.loading = false;
                }
            }
        }
    }
</script>